import { canScore, answerChoices, normalizeAnswer } from './evaluationIntegrity';

/** #Fase1-10 — El peso por nombre debe ser visible antes de activar una plantilla. */
function baseSectionWeight(section) {
  if (section.weight != null) return Number(section.weight);
  const name = normalizeAnswer(section.name || section.title || section.section_name);
  if (name.includes('evento')) return 25;
  if (/secur|segur/.test(name)) return 35;
  if (/safety|protec|civil/.test(name)) return 40;
  return 0;
}

export function effectiveSectionWeight(section, sections = [section]) {
  const weight = baseSectionWeight(section);
  if (weight > 0 || !(section.questions || []).some(canScore)) return weight;
  // R2: incluye pesos por palabra clave; el respaldo no vuelve a promediarse.
  const weighted = sections.map(baseSectionWeight).filter(value => value > 0);
  return weighted.length ? weighted.reduce((sum, value) => sum + value, 0) / weighted.length : 1;
}

export function weightSummary(sections) {
  const total = sections.reduce((sum, section) => sum + effectiveSectionWeight(section, sections), 0);
  return { total, excluded: [] };
}

export function criticalRequirements(requirements = {}) {
  const next = { ...requirements };
  ['observation', 'photo', 'geo'].forEach((key) => {
    if (!next[key] || next[key] === 'never') next[key] = 'below_standard';
  });
  return next;
}

/** Bloquear cambios que harían invisibles para siempre a los dependientes, sin borrar decisiones. */
export function templateQuestionError(question, previousQuestions, allQuestions) {
  if (
    question.question_type === 'yes_no' &&
    question.scoring_enabled &&
    !question.favorable_answer
  ) {
    return 'Elige la respuesta favorable para que Sí/No califique.';
  }
  if (question.visible_if) {
    const parent = previousQuestions.find(
      (candidate) => candidate.id === question.visible_if.question_id
    );
    const valid = answerChoices(parent || {}).map(normalizeAnswer);
    if (!parent) return 'La pregunta de la condición no es una pregunta anterior válida.';
    if (!question.visible_if.answers?.length)
      return 'Elige al menos una respuesta que active la pregunta.';
    if (question.visible_if.answers.some((answer) => !valid.includes(normalizeAnswer(answer)))) {
      return 'La condición contiene respuestas que ya no existen en la pregunta anterior.';
    }
  }
  const valid = answerChoices(question).map(normalizeAnswer);
  const broken = allQuestions.find(
    (candidate) =>
      candidate.visible_if?.question_id === question.id &&
      (candidate.visible_if.answers || []).some(
        (answer) => !valid.includes(normalizeAnswer(answer))
      )
  );
  return broken
    ? `El cambio dejaría sin condición válida a «${broken.title}». Actualiza primero su condición.`
    : '';
}

/** La UI solo confirma el nuevo orden cuando la API lo acepta; un rechazo conserva el anterior. */
export async function persistOrder({ before, after, save, apply, onError, lock, onPendingChange }) {
  // #Fase1-10 — Ignorar otro arrastre en vuelo evita revertir a un snapshot optimista rechazado.
  if (lock?.current) return false;
  if (lock) lock.current = true;
  onPendingChange?.(true);
  try {
    apply(after);
    await save();
    return true;
  } catch (error) {
    apply(before);
    onError(error);
    return false;
  } finally {
    if (lock) lock.current = false;
    onPendingChange?.(false);
  }
}
